import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { combineReducers } from '@reduxjs/toolkit';
import { FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER } from 'redux-persist';

// Importar slices
import authSlice from './slices/authSlice';
import companySlice from './slices/companySlice';
import uiSlice from './slices/uiSlice';
import notificationsSlice from './slices/notificationsSlice';
import transactionsSlice from './slices/transactionsSlice';
import bankAccountSlice from './slices/bankAccountSlice';

// =====================================================
// CONFIGURAÇÃO DO PERSIST
// =====================================================

/** Chave usada pelo redux-persist no localStorage: `persist:${PERSIST_KEY}` (lida pelo ApiService) */
export const PERSIST_KEY = 'falavippay-root';

const persistConfig = {
  key: PERSIST_KEY,
  version: 1,
  storage,
  whitelist: ['auth', 'company', 'ui', 'bankAccount'], // Apenas alguns slices serão persistidos
  blacklist: ['notifications', 'transactions'], // Dados que não devem ser persistidos
};

// =====================================================
// ROOT REDUCER
// =====================================================

const rootReducer = combineReducers({
  auth: authSlice,
  company: companySlice,
  ui: uiSlice,
  notifications: notificationsSlice,
  transactions: transactionsSlice,
  bankAccount: bankAccountSlice,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

// =====================================================
// STORE CONFIGURATION
// =====================================================

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [FLUSH, REHYDRATE, PAUSE, PERSIST, PURGE, REGISTER],
      },
    }).concat([
      // Adicionar middleware customizado se necessário
    ]),
  devTools: import.meta.env.DEV,
});

export const persistor = persistStore(store);

// =====================================================
// TYPES
// =====================================================

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// =====================================================
// SELECTORS HELPER
// =====================================================

export const selectAuth = (state: RootState) => state.auth;
export const selectCompany = (state: RootState) => state.company;
export const selectUI = (state: RootState) => state.ui;
export const selectNotifications = (state: RootState) => state.notifications;
export const selectTransactions = (state: RootState) => state.transactions;
export const selectBankAccountState = (state: RootState) => state.bankAccount;

export default store;